import { parseISO } from "date-fns"
import { MILLISECONDS_IN_HOUR, MILLISECONDS_IN_MINUTE } from "@/lib/format-date"

const defaultFormat = {
  hour: "h",
  minute: "'",
}

const getDateTimeOrParseDateTimeAsIso = (dateTime: Date | string) => {
  if (typeof dateTime === "string") {
    return parseISO(dateTime)
  }
  return dateTime
}

// get duration to now in milliseconds
const getDurationToNow = (dateTime: Date | string): number => {
  return new Date().getTime() - getDateTimeOrParseDateTimeAsIso(dateTime).getTime()
}

const getDurationToNowInMinutes = (dateTime: Date | string): number => {
  const duration = getDurationToNow(dateTime)
  return Math.floor(duration / MILLISECONDS_IN_MINUTE)
}

const getDurationToNowInHours = (dateTime: Date | string): number => {
  const duration = getDurationToNow(dateTime)
  return Math.floor(duration / MILLISECONDS_IN_HOUR)
}

const formatDurationToNow = (
  dateTime: Date | string,
  format: { hour: string; minute: string } = defaultFormat,
): string => {
  const localDateTime = getDateTimeOrParseDateTimeAsIso(dateTime)

  const durationInHours = Math.abs(getDurationToNowInHours(localDateTime))
  const durationInMinutes = Math.abs(getDurationToNowInMinutes(localDateTime))

  if (durationInHours < 1) {
    return `${durationInMinutes < 1 ? durationInMinutes + 1 : durationInMinutes}${format.minute}`
  }
  return `${durationInHours}${format.hour}`
}

export { getDurationToNow, getDurationToNowInMinutes, getDurationToNowInHours, formatDurationToNow }
